import ProductProgressCard from './ProductProgressCard';

export default ProductProgressCard;
